import React from 'react';

// Escudo anti-pantalla-blanca. Si cualquier parte de la app lanza un error de
// renderizado, en vez de dejar la pantalla en blanco mostramos un mensaje
// amable con un botón para recargar. El detalle técnico va plegado, para que
// un tester pueda capturarlo y reportarlo sin asustarse.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Queda en la consola del navegador para diagnóstico.
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturó un error:', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const err = this.state.error;
    const detalle = (err && (err.stack || err.message)) || 'Sin detalle disponible';

    return (
      <div style={estilos.fondo}>
        <div style={estilos.tarjeta}>
          <div style={{ fontSize: '52px', marginBottom: '8px' }}>🌸</div>
          <h1 style={estilos.titulo}>Ups, algo se tropezó</h1>
          <p style={estilos.texto}>
            No te preocupes, <b>tu información está a salvo</b>. Solo necesitamos
            recargar la página para seguir.
          </p>

          <button style={estilos.botonPrincipal} onClick={() => window.location.reload()}>
            🔄 Recargar la app
          </button>
          <button style={estilos.botonSecundario} onClick={() => { window.location.href = '/'; }}>
            Ir al inicio
          </button>

          <details style={estilos.detalle}>
            <summary style={estilos.summary}>Ver detalle técnico (para reportar)</summary>
            <pre style={estilos.pre}>{detalle}</pre>
          </details>

          <p style={estilos.pie}>
            Si sigue pasando, mandale una captura de esto a Automatika.ia. 💜
          </p>
        </div>
      </div>
    );
  }
}

const estilos = {
  fondo: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundColor: '#FDF2F8', fontFamily: 'Arial, sans-serif', padding: '16px',
  },
  tarjeta: {
    maxWidth: '440px', width: '100%', backgroundColor: '#fff', borderRadius: '16px',
    padding: '32px 24px', textAlign: 'center', boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
  },
  titulo: { fontSize: '22px', margin: '0 0 8px', color: 'var(--color-primario,#DB2777)' },
  texto: { fontSize: '15px', color: '#4B5563', margin: '0 0 20px', lineHeight: 1.5 },
  botonPrincipal: {
    width: '100%', padding: '14px', backgroundColor: 'var(--color-primario,#DB2777)', color: '#fff',
    border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer',
    marginBottom: '10px',
  },
  botonSecundario: {
    width: '100%', padding: '12px', backgroundColor: '#fff', color: '#6B7280',
    border: '1px solid #E5E7EB', borderRadius: '10px', fontSize: '14px', cursor: 'pointer',
  },
  detalle: { marginTop: '20px', textAlign: 'left' },
  summary: { fontSize: '13px', color: '#9CA3AF', cursor: 'pointer' },
  pre: {
    marginTop: '8px', maxHeight: '160px', overflow: 'auto', backgroundColor: '#F9FAFB',
    border: '1px solid #F3F4F6', borderRadius: '8px', padding: '10px', fontSize: '11px',
    color: '#6B7280', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
  },
  pie: { fontSize: '12px', color: '#9CA3AF', margin: '18px 0 0' },
};
